import { render, staticRenderFns } from "./DuplicateSeatingChartModal.vue?vue&type=template&id=763de6d0"
import script from "./DuplicateSeatingChartModal.vue?vue&type=script&lang=js"
export * from "./DuplicateSeatingChartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports